import { createContext } from 'react';
import { CoursePlayAssignment } from '../../entities/Assignment';

export const CourseAssignmentsContext = createContext<
  CoursePlayAssignment[] | undefined
>([]);
